export class Coverage {
  constructor(private readonly total: number, private readonly covered: number, private readonly depth: number | null) {}

  getTotal() {
    return this.total;
  }

  getCovered() {
    return this.covered;
  }

  getDepth() {
    return this.depth;
  }

  getPercent() {
    if (this.total === 0) {
      return (0.0).format({ decimals: 2 });
    }
    return ((100.0 * this.covered) / this.total).format({ decimals: 2 });
  }
}
